import styled from 'styled-components';
import imageSources from '../../../constants/imageSources/imageSources';

interface DivProps {
    isEnabled: boolean;
    imageSource?: string;
    isDragging: boolean;
    border?: string;
}
export const Div = styled.div<DivProps>`
    position: relative;
    display: flex;
    align-items: flex-end;
    width: 163px;
    height: 54px;
    margin-bottom: 8px;
    background-color: transparent;
    cursor: url("${({ isEnabled }) =>
        isEnabled ? imageSources.ICONS.GRAB_CURSOR : imageSources.ICONS.LOCK_OUTLINE}"), default;
    cursor: ${({ isEnabled }) => (isEnabled ? 'grab' : 'not-allowed')}};
    background-image: url("${(props) => props.imageSource}");
    background-position: center;
    border-radius: 3px;
    box-sizing: border-box;
    opacity: ${({ isDragging }) => (isDragging ? 0.25 : 1)};
    :hover {
        border: ${({ isEnabled, border }) => `1px solid ${isEnabled ? border : 'transparent'}`};
    }
`;

export const BlockHeading = styled.h3`
    margin-bottom: 5px;
    ${Div}:hover & {
        margin-bottom: 4px;
    }
    width: 100%;
    text-align: center;
    font-weight: 600;
    font-size: 12px;
    padding: 0 2px;
    color: ${({ theme }) => theme.colors.neutral700};
    overflow-wrap: break-word;
    hyphens: auto;
`;

export const Img = styled.img`
    width: 100%;
`;

export const PresetBlocksWrapper = styled.div`
    margin-top: 20px;
    position: relative;
    height: calc(100% - 80px);
    overflow-y: scroll;
    overflow-x: hidden;
`;

interface SBDivProps {
    backgroundColor: string;
    hoverBorderColor: string;
}
export const SBDiv = styled(Div)<SBDivProps>(({ color, theme, backgroundColor, hoverBorderColor }) => {
    const border = `1px solid ${color === '#FFFFFF' ? theme.colors.neutral100 : 'transparent'}`;
    return {
        border,
        backgroundColor,
        flexDirection: 'column',
        alignItems: 'center',
        padding: 8,
        ':hover': {
            border: `1px solid ${color === '#FFFFFF' ? theme.colors.neutral300 : hoverBorderColor}`,
        },
    };
});

export const BlockIconWrapper = styled.div({
    display: 'flex',
    marginBottom: 4,
});

export const SBLogo = styled.img({
    borderRadius: 4,
    width: 20,
    height: 20,
});

export const LineWrapper = styled.div<{ filter: string }>(({ filter }) => ({
    filter,
    height: 20,
    width: 36,
}));

export const Line = styled.div<{ width: string }>(({ width, color, theme }) => ({
    width,
    backgroundColor: color === '#FFFFFF' ? theme.colors.neutral100 : color,
    height: 2,
    margin: 3,
}));

/**
 * Brightness filter doesn't work with the low alpha background of the SB block.
 * This overlays a transparent black div to achieve the same effect
 */
export const Dimmer = styled.div({
    borderRadius: 3,
    width: 163,
    height: 54,
    backgroundColor: 'rgba(0,0,0,0.2)',
    position: 'absolute',
    top: 62,
});
